/**
 * Helpers
 */

const selectors = {
    toggle: '.js-reveal',
    revealContent: '.js-reveal-content'
};

const classes = {
    isRevealed: 'is-revealed',
    isOpen: 'is-open'
};

/**
 * Main
 */
const toggles = [...document.querySelectorAll(selectors.toggle)];

if (toggles.length) {
    toggles.forEach((toggle) => {
        const revealContent = toggle.querySelector(selectors.revealContent);
        const revealItems = [...revealContent.children];
        // get vendor transition property
        const docElemStyle = document.documentElement.style;
        const transitionProp =
            typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';
        let isOpen = false;
        toggle.addEventListener('click', () => {
            toggle.classList.toggle(classes.isOpen);
            if (isOpen) {
                revealItems
                    .slice()
                    .reverse()
                    .forEach((item, index) => {
                        item.style[transitionProp + 'Delay'] = index * 100 + 'ms';
                        item.classList.remove(classes.isRevealed);
                    });
                let closeIndex = 0;
                if (revealItems.length > 1) {
                    closeIndex = 1;
                }
                revealItems[closeIndex].addEventListener(
                    'transitionend',
                    function removeHeight() {
                        revealContent.style.maxHeight = '0px';
                        revealItems[closeIndex].removeEventListener(
                            'transitionend',
                            removeHeight,
                            false
                        );
                    },
                    false
                );
                isOpen = false;
            } else {
                revealContent.style.maxHeight = `${revealContent.scrollHeight}px`;
                revealContent.addEventListener(
                    'transitionend',
                    function showItems() {
                        revealItems.forEach((item, index) => {
                            item.style[transitionProp + 'Delay'] = index * 100 + 'ms';
                            item.classList.add(classes.isRevealed);
                            revealContent.style.maxHeight = 'none';
                        });
                        revealContent.removeEventListener('transitionend', showItems, false);
                    },
                    false
                );
                isOpen = true;
            }
        });
    });
}

/**
 * Twig
 *
    <ul>
        {% for item in props.accordionItems %}
            <li class="js-reveal">
                <span class="flex justify-between">
                    <h4>{{ item.heading }}</h4>
                    {% include '_objects/toggle'  %}
                </span>
                <ul class="relative js-reveal-content reveal-content">
                    {{ item.summary | raw }}
                </ul>
            </li>
        {% endfor %}
    </ul>
*/
